/* eslint-disable @typescript-eslint/no-unused-vars */

import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { standaloneReducerBase } from './RootStore';

const appReducer = combineReducers({
    ...(standaloneReducerBase ?? {}),
});

const appStore = configureStore({
    reducer: appReducer,
    devTools: {
        name: 'L2D Recouvrement Store',
    },
});

export type RootStateType = ReturnType<typeof appStore.getState>;
export type AppDispatch = typeof appStore.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootStateType> = useSelector;
